import { Record } from 'immutable';
import { EventCollisionModalResponseEnum } from './event-collision-modal-response.enum';

const EventCollisionModalResponseRecord = Record({
  selectedButton: null,
  selectedMatches: null,
});

export class EventCollisionModalResponse extends EventCollisionModalResponseRecord {
  selectedButton: EventCollisionModalResponseEnum;
  selectedMatches: number[];
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/event-collision-modal/event-collision-modal-response.ts